<template>
  <v-layout class="comment-box">
    <v-container>
      <Disqus
        v-if="metadata"
        shortname="happyly-1"
        :identifier="metadata.identifier"
        :url="metadata.url"
      ></Disqus>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    metadata() {
      const baseURL = 'https://happyly.com'
      if (!this.model) return null

      switch (this.type) {
        case 'activity':
          return {
            url: `${baseURL}/activity/${this.model.slug}`,
            identifier: `/activity/${this.model.slug}`,
            title: this.model.headline,
          }
        case 'plan':
          return {
            url: `${baseURL}/curated_plans/${this.model.id}`,
            identifier: `/curated_plans/${this.model.id}`,
            title: this.model.name,
          }
        case 'blogpost':
          return {
            url: `${baseURL}/blog/${this.model.slug}`,
            identifier: `/blog/${this.model.slug}`,
            title: this.model.title,
          }
        default:
          return null
      }
    },
  },
}
</script>
